// Template194: Bangkok - Siam (Día 3). Idéntico a PageSiam.jsx. borderRadius: "12px".

import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import SabiasQue from "../SabiasQue";

const Template194 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page?.texts?.[0]?.content ?? "Día 3: Contrastes urbanos";
	const intro = page?.texts?.[1]?.content;
	const titleOverlay = page?.texts?.[2]?.content;
	const zonaTitle = page?.texts?.[3]?.content;
	const zonaP1 = page?.texts?.[4]?.content;
	const zonaP2 = page?.texts?.[5]?.content;
	const zonaP3 = page?.texts?.[6]?.content;
	const zonaP4 = page?.texts?.[7]?.content;
	const zonaP5 = page?.texts?.[8]?.content;
	const btsText = page?.texts?.[9]?.content;
	const jimTitle = page?.texts?.[10]?.content;
	const jimBody = page?.texts?.[11]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};
	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const portadaImage = getImageSrc("portada");
	const casaImage = getImageSrc("casa");
	const stickerUrl = getCanvasImageUrl("sticker");
	const logoImage = getCanvasImageUrl("logo");
	const sabiasQue = Array.isArray(page?.data?.sabiasQue)
		? page.data.sabiasQue
		: [];
	const actualHeaderColor = headerBackgroundColor || "#E8A838";

	const h3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: "14px",
		fontWeight: 700,
		textTransform: "uppercase",
		margin: "0 0 4px 0",
	};
	const h4Amarillo = {
		margin: "0 0 8px 0",
		fontSize: "13px",
		fontWeight: 700,
		color: "#E8A838",
		textTransform: "uppercase",
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
	};
	const p = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: "13px",
		color: "#444",
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				position: "relative",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1,
				}}
			>
				{headerText}
				{logoImage && (
					<Box
						component="img"
						src={logoImage}
						alt=""
						sx={{
							width: isSmallScreen ? 66 : 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			<Box data-block-id="image-0" sx={{ position: "relative" }}>
				{portadaImage && (
					<Box
						component="img"
						src={portadaImage}
						alt=""
						sx={{ width: "100%", height: 200, objectFit: "cover" }}
					/>
				)}
				{stickerUrl && (
					<Box
						component="img"
						src={stickerUrl}
						alt=""
						sx={{
							width: 100,
							position: "absolute",
							bottom: -10,
							right: isSmallScreen ? 10 : -20,
						}}
					/>
				)}
				{titleOverlay && (
					<Box
						component="h1"
						sx={{
							fontSize: isSmallScreen ? 26 : 32,
							position: "absolute",
							bottom: 0,
							margin: 1.25,
							left: 20,
							color: "#fff",
							textShadow: "2px 2px 4px rgba(0,0,0,0.6)",
						}}
					>
						{titleOverlay}
					</Box>
				)}
			</Box>

			<Box data-block-id="text-1" sx={{ padding: "10px 12px", position: "relative" }}>
				{intro && (
					<Box component="p" sx={p}>
						{intro}
					</Box>
				)}
			</Box>

			<Box
				data-block-id="text-2"
				sx={{
					padding: "8px 12px",
					marginBottom: 1,
					marginTop: -0.5,
					position: "relative",
				}}
			>
				{sabiasQue.length > 0 && (
					<Box sx={{ position: "absolute", top: -8, left: "50%", zIndex: 2 }}>
						<SabiasQue
							icono={sabiasQue[0]?.icono ?? "🛍️"}
							texto={sabiasQue[0]?.texto ?? ""}
						/>
					</Box>
				)}
				<Box
					sx={{
						backgroundColor: "#FFF3CD",
						border: "3px solid #E8A838",
						borderRadius: "12px",
						padding: "12px 16px",
						fontSize: "12px",
						color: "#333",
						width: "100%",
					}}
				>
					<Box component="h4" sx={h4Amarillo}>
						{zonaTitle}
					</Box>
					{zonaP1 && (
						<Box
							component="p"
							sx={{ margin: "0 0 8px 0" }}
							dangerouslySetInnerHTML={{ __html: zonaP1 }}
						/>
					)}
					{zonaP2 && (
						<Box
							component="p"
							sx={{ margin: "0 0 8px 0" }}
							dangerouslySetInnerHTML={{ __html: zonaP2 }}
						/>
					)}
					{zonaP3 && (
						<Box
							component="p"
							sx={{ margin: "0 0 8px 0" }}
							dangerouslySetInnerHTML={{ __html: zonaP3 }}
						/>
					)}
					{zonaP4 && (
						<Box
							component="p"
							sx={{ margin: "0 0 8px 0" }}
							dangerouslySetInnerHTML={{ __html: zonaP4 }}
						/>
					)}
					{zonaP5 && (
						<Box
							component="p"
							sx={{ margin: 0 }}
							dangerouslySetInnerHTML={{ __html: zonaP5 }}
						/>
					)}
				</Box>
			</Box>

			{btsText && (
				<Box
					data-block-id="text-3"
					sx={{
						display: "flex",
						gap: 2,
						padding: "0 12px",
						position: "relative",
					}}
				>
					<Box sx={{ width: "100%" }}>
						<Box
							sx={{
								backgroundColor: "#FFF3CD",
								padding: 1.5,
								borderRadius: "12px",
							}}
						>
							<Box component="p" sx={p}>
								{btsText}
							</Box>
						</Box>
					</Box>
				</Box>
			)}

			<Box
				data-block-id="text-4"
				sx={{
					padding: "0 12px",
					paddingBottom: "5px",

					marginTop: 1.75,
				}}
			>
				<Box
					sx={{
						display: "flex",
						gap: 2,
						marginBottom: isSmallScreen ? "12px" : 1.75,
						alignItems: "flex-start",
					}}
				>
					{casaImage && (
						<Box
							component="img"
							src={casaImage}
							alt=""
							sx={{
								width: "40%",
								height: 100,
								borderRadius: "12px",
								objectFit: "cover",
							}}
						/>
					)}
					<Box sx={{ width: "60%", position: "relative" }}>
						<Box component="h3" sx={h3}>
							{jimTitle}
						</Box>
						{jimBody && (
							<Box component="p" sx={p}>
								{jimBody}
							</Box>
						)}
					</Box>
				</Box>
			</Box>
		</Box>
	);
};

Template194.thumbnail = "/images/template-1.png";
export default Template194;
